module.exports = __webpack_public_path__ + "img/lock-icon.49b74206.svg";